import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import GoogleMapHandlerComponent from "views/Maps/GoogleMapHandlerComponent";

import { SET_CAMPSITE_LOCALIZATION } from "actions/types.js";

class Step3 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	onMarkerChange = (latitude, longitude) => {
		this.props.dispatch({
			type: SET_CAMPSITE_LOCALIZATION,
			value: {
				type: "Point",
				coordinates: [longitude, latitude]
			}
		});
	};

	render() {
		const { latitude, longitude, dispatch } = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDTypography
						variant="h6"
						fontWeight="light"
						textAlign="center"
						mt={1}
						mb={2}
					>
						Veuillez localiser le camping sur la carte en déplaçant le marqueur
					</MDTypography>
				</Grid>
				<Grid item xs={12}>
					<MDBox height="480px" borderRadius="md" overflow="hidden">
						<GoogleMapHandlerComponent
							dispatch={dispatch}
							zoom={15}
							latitude={latitude}
							longitude={longitude}
							onMarkerChange={this.onMarkerChange}
							onGetCurrentPosition={this.onMarkerChange}
						/>
					</MDBox>
				</Grid>
				<Grid item xs={6} sm={3}>
					<MDInput
						label="Latitude"
						id="latitude"
						fullWidth
						type="number"
						value={latitude ? latitude : 0}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_LOCALIZATION,
								value: {
									type: "Point",
									coordinates: [longitude, parseFloat(e.target.value)]
								}
							})
						}
					/>
				</Grid>
				<Grid item xs={6} sm={3}>
					<MDInput
						label="Longitude"
						id="longitude"
						fullWidth
						type="number"
						value={longitude ? longitude : 0}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_LOCALIZATION,
								value: {
									type: "Point",
									coordinates: [parseFloat(e.target.value), latitude]
								}
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const [longitude = 0, latitude = 0] =
		state.campsiteReducer.loc?.coordinates || [];
	return {
		longitude,
		latitude
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step3
);
